import mixpanel from 'mixpanel-browser';

const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

// Skip Mixpanel entirely when no token is configured (e.g. preview builds):
// calling it uninitialized throws and takes down the app.
if (token) {
  mixpanel.init(token, {
    debug: process.env.NODE_ENV === 'development',
    track_pageview: true,
    persistence: 'localStorage',
  });
}

// User Properties
export const identify = (userId: string, properties?: Record<string, any>) => {
  if (!token) return;
  mixpanel.identify(userId);
  if (properties) {
    mixpanel.people.set(properties);
  }
};

// Event Tracking
export const track = (eventName: string, properties?: Record<string, any>) => {
  if (!token) return;
  mixpanel.track(eventName, properties);
};

// Page Views
export const trackPageView = (pageName: string) => {
  if (!token) return;
  mixpanel.track('Page View', { page: pageName });
};

// Reset User
export const reset = () => {
  if (!token) return;
  mixpanel.reset();
};
